import React, { createRef, useEffect, useRef, useState } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import { scroller } from 'react-scroll';
import { findIndex, isEmpty, kebabCase } from 'lodash';
import { useLocation } from '@reach/router';
import googleMapStyles from '../../assets/data/map-style.json';
import CustomMarker from '../../assets/svg/map-marker.svg';
import DarkLogo from '../../images/dsw_logo-dark.png';


export function Maps({ data, google, dir }) {
  const [selectedElement, setSelectedElement] = useState({});
  const [selectedContent, setSelectedContent] = useState({});
  const markerRefs = useRef(data.locationList.map(() => createRef()));
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    if (markerRefs && markerRefs.current) {
      const index = findIndex(
        data.locationList,
        ({ content }) => kebabCase(content.title) === hash.replace('#', ''),
      );
      if (index >= 0) {
        scroller.scrollTo('google-map-container', {
          duration: 1500,
          delay: 100,
          smooth: true,
          offset: -220,
        })
        google.maps.event.trigger(markerRefs.current[index].current.marker, 'click');
      }
    }
  }, [hash, markerRefs, google]);

  return (
    <div className="min-h-[30rem] md:min-h-[49.5rem]" id="google-map-container">
      <div
        className="md:h-[720px] h-[400px] google-map:md:!h-[720px] google-map:!h-[400px]"
        dir={dir}>
        <Map
          google={google}
          zoom={17}
          styles={googleMapStyles}
          initialCenter={{
            lat: 25.223061640468806,
            lng: 55.289572379330586,
          }}
          mapTypeControl={false}
          heading={320}
          tilt={47.5}
          rotate={20}>
          {isEmpty(data.locationList) ||
            isEmpty(markerRefs) ||
            data.locationList.map(({ content }, index) => {
              const [lat2, lng2] = content.geoLocation.split(',');
              if (index) {
                return (
                  <Marker
                    key={index}
                    ref={markerRefs.current[index]}
                    id={kebabCase(content.title)}
                    title={content.title}
                    icon={{
                      url: CustomMarker,
                      scaledSize: new google.maps.Size(15, 18),
                    }}
                    position={{
                      lat: lat2,
                      lng: lng2,
                    }}
                    onClick={(props, marker) => {
                      setSelectedElement(marker);
                      setSelectedContent(content);
                    }}
                  />
                );
              }
              return (
                <Marker
                  key={index}
                  title={content.title}
                  icon={{
                    url: DarkLogo,
                    scaledSize: new google.maps.Size(100, 46),
                  }}
                  position={{
                    lat: lat2,
                    lng: lng2,
                  }}
                />
              );
            })}
          {isEmpty(selectedContent) || isEmpty(selectedElement) || (
            <InfoWindow
              visible
              marker={selectedElement}
              onCloseClick={() => {
                setSelectedElement({});
                setSelectedContent({});
              }}>
              <div className="flex flex-col justify-center gap-y-1 !max-w-[220px]">
                {selectedContent.title && (
                  <h2 className="font-roboto-bold text-darkGrey text-[14px]">
                    {selectedContent.title}
                  </h2>
                )}
                {selectedContent.address && (
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedContent.address }}
                    className="text-[13px] font-roboto-regular text-darkGrey flex flex-col
                    gap-y-0.5"
                  />
                )}
                {isEmpty(selectedContent.link) || (
                  <a
                    href={selectedContent.link.url}
                    target={selectedContent.link.target}
                    className="text-clearBlue text-[13px] font-roboto-regular">
                    {selectedContent.link.name}
                  </a>
                )}
              </div>
            </InfoWindow>
          )}
        </Map>
      </div>
    </div>
  );
}

Maps.defaultProps = googleMapStyles;

export default GoogleApiWrapper({
  apiKey: process.env.GATSBY_GOOGLE_API_KEY,
})(Maps);
